/**
 * Uso de una cuenta (puro). Dice si su dinero está disponible para ti:
 * - Disponible: cuenta para tu dinero disponible y tu colchón (lo normal).
 * - Apartada para pagos: es tuya (cuenta en patrimonio), pero tiene un fin (el piso, el coche, los gastos de casa con
 *   compañeros…): no cuenta en tu dinero disponible ni en el colchón. Lo que le pasas sale de tu dinero disponible.
 * - Uso limitado: solo sirve para ciertas cosas (vales de comida, transporte, tarjetas regalo): es liquidez, pero no colchón.
 * Se guarda en Cuentas M ('Disponible', 'Apartada: <para qué>', 'Uso limitado'). Sin decir, las de comida (Tickets, Pluxee…)
 * son de uso limitado, como hasta ahora, y el resto disponibles.
 */
export type AccountUse = 'available' | 'reserved' | 'limited';
export interface AccountUseInfo { use: AccountUse; purpose: string }

/** Cuentas de comida reconocidas por su tipo o su nombre (para libros sin «Uso»). */
const looksMeal = (a: { name: string; type?: string }) =>
  /^(meal|vales?|tarjeta comida)$/i.test((a.type ?? '').trim()) || /ticket|pluxee|edenred|sodexo|cheque gourmet/i.test(a.name);

export function accountUse(a: { name: string; type?: string; use?: string }): AccountUseInfo {
  const raw = (a.use ?? '').trim();
  if (/^apartad/i.test(raw)) return { use: 'reserved', purpose: raw.replace(/^apartad[ao]s?(\s+para\s+pagos)?\s*[:·-]?\s*/i, '').trim() };
  if (/^uso limitado/i.test(raw)) return { use: 'limited', purpose: '' };
  if (/^disponible/i.test(raw)) return { use: 'available', purpose: '' };
  return { use: looksMeal(a) ? 'limited' : 'available', purpose: '' };
}

/** Lo que se escribe en Cuentas M. */
export const useCell = (u: AccountUseInfo): string =>
  u.use === 'reserved' ? `Apartada${u.purpose.trim() ? `: ${u.purpose.trim()}` : ''}` : u.use === 'limited' ? 'Uso limitado' : 'Disponible';

export const USE_LABEL: Record<AccountUse, { title: string; help: string }> = {
  available: { title: 'Disponible', help: 'Cuenta para tu dinero disponible y tu colchón.' },
  reserved: { title: 'Apartada para pagos', help: 'Es tuya (cuenta en tu patrimonio), pero tiene un fin: el piso, el coche, los gastos de casa… No cuenta en tu dinero disponible ni en el colchón; lo que le pasas sale de tu dinero disponible.' },
  limited: { title: 'Uso limitado', help: 'Solo sirve para ciertas cosas (vales de comida, transporte, tarjetas regalo): cuenta como dinero disponible, pero no como colchón.' },
};
